import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { useAppContext } from "@/contexts/AppContext";

const NAV_ITEMS = [
  { to: "/admin",                    label: "Dashboard",           end: true,  icon: null      },
  { to: "/admin/products",           label: "Products",            end: false, icon: null      },
  { to: "/admin/manufacturers",      label: "Manufacturers",       end: true,  icon: null      },
  { to: "/admin/retailers",          label: "Retailers",           end: true,  icon: null      },
  { to: "/admin/pricing-calculator", label: "Pricing Calculator",  end: true,  icon: null      },
  { to: "/admin/catalogue-requests", label: "Catalogue Requests",  end: true,  icon: null      },
  { to: "/admin/pipeline",           label: "Pipeline",            end: true,  icon: null      },
  { to: "/admin/analytics",          label: "Analytics",           end: true,  icon: BarChart3 },
  { to: "/admin/materials",          label: "Material Library",    end: true,  icon: null      },
  { to: "/admin/quality",            label: "Quality",             end: true,  icon: null      },
  { to: "/admin/send-invoice",       label: "Send Invoice",        end: true,  icon: null      },
  { to: "/admin/feature-flags",       label: "Feature Flags",       end: true,  icon: null      },
  { to: "/admin/settings",           label: "Settings",            end: true,  icon: null      },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const { signOut } = useAppContext();

  async function handleSignOut() {
    await signOut();
    navigate("/");
  }

  return (
    <div className="space-y-5">
      <nav className="border-b border-gray-800 pb-0 flex items-center justify-between">
        <ul className="flex flex-wrap gap-0">
          {NAV_ITEMS.map(({ to, label, end, icon: Icon }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) =>
                  [
                    "inline-flex items-center gap-1.5 px-4 py-2.5 text-sm border-b-2 transition-colors",
                    isActive
                      ? "border-orange-500 text-orange-400 font-medium"
                      : "border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-700",
                  ].join(" ")
                }
              >
                {Icon && <Icon size={14} className="shrink-0" />}
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
        <button
          onClick={handleSignOut}
          className="inline-block px-4 py-2.5 text-sm border-b-2 border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-700 transition-colors"
        >
          Sign out
        </button>
      </nav>
      <Outlet />
    </div>
  );
}
